<a>
  <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" matTooltip="Api Token löschen" (click)="deleteApiToken()">Entfernen</button>
</a>

